import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

let Home = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  useEffect(() => {
    Start();
    Payment();
  }, []);

  let  [ fastag , setFastag ] = useState(0)
  let [ eel , setEel ] =  useState(0)
  let [ ccc , setccc ] =  useState(0)
  let [ predata , setpredata ] =  useState(0)
  let [ insu , setInsu ] =  useState(0)
  let [ ggs , setGgs ] =  useState(0)

  let [ post , setPost ] =  useState(0)
 
  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Payment = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/payment",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

         let hh =0 
         let ft = 0
         let cc = 0
         let pre = 0
         let insa = 0
         let gass = 0
         let poss = 0

          Jsson?.bbps?.map((der , inex)=>{
                if (der?.category === "Fastag" ){
                  hh = hh +1
                }else if( der?.category === "Electricity") { 
                   ft = ft +1
                }else if ( der?.category === "Creditcard" ){
                  cc = cc +1
                }else if( der?.category === "Prepaid" ){
                  pre = pre + 1 
                }else if (der?.category === "Insurance"){
                  insa = insa + 1
                }else if (der?.category === "LPG Gas"){
                  gass = gass + 1
                }else if (der?.category === "Postpaid"){
                  poss = poss + 1
                }
              })
              setPost(poss)
              setGgs(gass)
              setInsu(insa)
              setpredata(pre)
              setFastag( hh )
              setEel (ft)
              setccc(cc)
          console.log(
            JSON.stringify(Jsson),
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );
          if (Jsson.status === true) {
            setData(Jsson.data);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  let clickedit = (re) =>{
    console.log(re, "ggggggggggggggggggggg");
    navigate("/editbbps", { state: re });
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-8" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }} >
          <div className="row mt-4">
            {data?.map((re, index) => {

              
 

              console.log(re, "ffffffffffffffffffffff");
              return ( 
                  <div
                    
                    className="col-3"
                  >
                    <div className="d-flex flex-row"  >
                      <div className="p-2" onClick={() => {
                      ClickCat(re);
                    }} >
                      <p>{re} {" "} <span style={{ color : "red" }} >({ re === "Fastag" ? fastag : re === "Electricity" ? eel : 
                      re === "Credit Card" ? ccc : re === "Mobile Prepaid" ? predata :
                      re === "Insurance" ? insu : re === "LPG Gas" ?  ggs  : 
                      re === "Mobile Postpaid" ? post  :   ""})</span></p>
                      </div>
                      <div className="p-2" >
                        <button  onClick={() => {
                      clickedit(re);
                    }} >Edit</button>
                      </div>
                    </div>
                   
                  </div> 
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
